import { render, staticRenderFns } from "./_tabNotes.vue?vue&type=template&id=a88598d6&"
import script from "./_tabNotes.vue?vue&type=script&lang=js&"
export * from "./_tabNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports